










































import { Component, Vue } from 'vue-property-decorator';
import SectionTuileNav from '@/components/shared/SectionTuileNav.vue'
import { ITuileNav } from '@/models/ui/ITuileNav'

@Component({
  name:'Reserver',
  components: { 
    SectionTuileNav   
  },
})
export default class Reserver extends Vue {
  
  

}
